import { NUMBER_OF_PROPERTIES_PER_PAGE } from "../constants";
export var getNumberOfPages = function getNumberOfPages(numberOfProperties) {
  return Math.ceil(numberOfProperties / NUMBER_OF_PROPERTIES_PER_PAGE);
};